import React, { useEffect } from 'react'
import { CssBaseline, ThemeProvider, Theme, Stack, Container } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { getTheme } from '../../store/settings/settings.selectors'
import { Route, Switch } from 'react-router'
import Home from './Home'
import Feedback from '../Feedback/Feedback'
import Header from '../../shared/components/LayoutComponents/Header'
import Footer from '../../shared/components/LayoutComponents/Footer'
import Env from '../../shared/config/envConfig'
import { setFeedback } from '../../store/settings/settings.actions'
import Day from './Day'

const App: React.FC = () => {
  const theme: Theme = useSelector(getTheme)
  const dispatch = useDispatch()

  const HomeApp = () => (<Home reloadFeedback={() => loadData()} />)
  const DayApp = () => (<Day reloadFeedback={() => loadData()} />)
  const FeedbackApp = () => (<Feedback reloadFeedback={() => loadData()} />)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    const basePath = Env.basePath
    const requestHeaders: HeadersInit = new Headers()
    requestHeaders.set('Accept', 'application/json')
    requestHeaders.set('Content-Type', 'application/json')

    const restUrl = `${basePath}/api/feedback`
    fetch(restUrl, {
      method: 'GET',
      credentials: 'include',
      headers: requestHeaders,
    })
      .then((res) => res.json())
      .then((response) => {
        dispatch(setFeedback(response))
      })
      .catch((err) => console.log(err))
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Stack sx={{ width: '100%' }}>
          <Header />
          <Container fixed>
            <Switch>
              <Route exact path='/' component={HomeApp} />
              <Route exact path='/day' component={DayApp} />
              <Route exact path='/bewertungen' component={FeedbackApp} />
            </Switch>
          </Container>
          <Footer />
        </Stack>
      </ThemeProvider>
    </>
  )
}

export default App
